import { SkeletonProps } from '@material-ui/lab/Skeleton';
import { ComponentsProps } from '@material-ui/core/styles/props';

export const muiSkeletonProps = (): ComponentsProps => ({
  MuiSkeleton: {
    variant: 'rect',
  },
});

declare module '@material-ui/core/styles/props' {
  export interface ComponentsPropsList {
    MuiSkeleton: SkeletonProps;
  }
}
